import type * as React from 'react';

/**
 * Panel to announce a new feature/update pushed by customer.io.
 *
 * Important: this component is always mounted so that at any time it can get replaced
 * remotely by an iframe panel served by customer.io.
 */
export function CustomerIOAlert(): React.ReactElement | null {
    return <div id="customerio-alert" />;
}
